import React from 'react'
import  NavbarPrice  from "./NavbarPrice";


export const Company = () => {
  return (
    <div className='container padding'>
     
      <div className='col-md-12'>

        <div className='row mx-0'>


          <p>

            <h2 className="text-success"> Spiccato Games </h2>
            <p className='text-light bg-dark'>
              Spiccato Games
            </p>
            
          </p>
        <img src="https://i.ibb.co/HXPnpyJ/Logos.png"></img>  
        
        </div>
      </div>
    </div>
  )
}

